const vapidKey = 'BF86ghAQUqqAXv56tBMfH03Bqfqdsxb1SsZ2ksEdYimc9We9c6gnbjcEGzx6ED4PVPl8lahN6zxlNpRQZJz_xNc'

const firebaseConfig = {
  apiKey: "AIzaSyBd1cmmeCSX4EuezAdvi1B3jdJtppmuIXM",
  authDomain: "zodiac-lms-slldt.firebaseapp.com",
  projectId: "zodiac-lms-slldt",
  storageBucket: "zodiac-lms-slldt.firebasestorage.app",
  messagingSenderId: "790043628843",
  appId: "1:790043628843:web:31b048e28e38f8342fa16e",
  measurementId: "G-MHS9JY6S56"
}

export { vapidKey, firebaseConfig }
